import api from "../../APIIntercepter";

async function updateBannerAPI(params) {
  const res = await api.put("/banner/admin", params);
  return res.data;
}

async function getPopupBannerAPI(status) {
  const res = await api.get(`/banner/popup?id=2&status=${status}`);
  return res.data;
}

async function updatePopupBannerAPI(params) {
  const res = await api.put("/banner/admin", params);
  return res.data;
}

async function getBannerAPI(status) {
  const res = await api.get(`/banner?id=1&status=${status}`);
  return res.data;
}

export { getBannerAPI, getPopupBannerAPI, updateBannerAPI, updatePopupBannerAPI };
